import {PATHS} from 'routes/constants';

const getRegistrationPath = (): string => PATHS.guestRegistration;

export {getRegistrationPath};
